// extracted by mini-css-extract-plugin
module.exports = {"container":"loader-video-status-button_container__1tTcg","icon":"loader-video-status-button_icon__2uFMa"};